import TextField from '@mui/material/TextField';
import { styled } from '@mui/system';

import { OPACITY_73 } from 'constants/opacity';
import {
  getMenuItemNamesLighterColor,
  getMenuItemNamesColor
} from 'styles/helpers/getThemeStyles';

export const StyledTextField = styled(TextField)(({ theme }) => {
  const fonts = {
    ...theme.typography.itemDescriptionsAndPrices
  };
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: `${getMenuItemNamesLighterColor(theme)} !important`
    },
    '& .MuiOutlinedInput-input': {
      color: getMenuItemNamesColor(theme),
      ...fonts
    },
    input: {
      '&::placeholder': {
        opacity: OPACITY_73
      }
    }
  };
});
